// extracted by mini-css-extract-plugin
export default {"card":"StatsCard_card__SFO07","SvgjsText1239":"StatsCard_SvgjsText1239__Iu7e6","statistic":"StatsCard_statistic__L2bIb","icon":"StatsCard_icon__K8eKT"};